import MobileSwitch from './MobileSwitch';
import type MobileSwitchProps from './MobileSwitch';

export default MobileSwitch;
export type { MobileSwitchProps };
